import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { PrimeNGConfig, MessageService } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';
import { PermissionsService } from '../../services/permission.service';

@Component({
  selector: 'app-nominations',
  standalone: false,
  templateUrl: './nominations.component.html',
  styleUrl: './nominations.component.scss',
})
export class NominationsComponent implements OnInit, OnDestroy, AfterViewInit {
  RFPForm: FormGroup;
  uploadedFiles: File[] = [];
  @Input() proposalName: any;
  @Input() proposalId: any;
  @Output() generatePDFEmitter = new EventEmitter<any>();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() step: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  uploadedUrl: any;
  apiUrl = environment.APIUrl;
  uploadedFileName: string = '';
  file: File;
  @Input() id: any;

  private subscriptions = new Subscription();
  userID: any;
  title = 'Members Table';
  showDialog: boolean = false;
  isUpdatedialog: boolean = false;
  roleForm: FormGroup;
  system: any[];
  // isCardView: boolean = true;
  cols: any[] = [
    {
      field: 'user.first_name',
      header: 'Fist Name',
      filterType: 'text',
      width: '100px',
      minWidth: '150px',
      maxWidth: '300px',
    },
    {
      field: 'user.last_name',
      header: 'Last Name',
      filterType: 'text',
      width: '100px',
      minWidth: '150px',
      maxWidth: '300px',
    },
    {
      field: 'unit',
      header: ' Directorate',
      filterType: 'text',
      width: '100px',
      minWidth: '150px',
      maxWidth: '300px',
    },
    {
      field: 'role',
      header: ' Role',
      filterType: 'text',
      width: '100px',
      minWidth: '150px',
      maxWidth: '300px',
    },
    {
      field: 'contact_details',
      header: 'Contact Details',
      filterType: 'text',
      width: '200px',
      minWidth: '150px',
      maxWidth: '300px',
    },
  ];
  selectedsystem: any;
  systemSection: any;
  showDeleteDialog: boolean = false;
  schemes: any;
  totalRecords: number = 0;
  userList: any;
  unitList: any;
  userListCopy: any;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute,
    private permissionService: PermissionsService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    this.roleForm = this.fb.group({
      directorate: ['', Validators.required],
      user: ['', Validators.required],
      contact: ['', Validators.required],
      roleName: ['', Validators.required],
    });
    this.getUserList();
    this.getUnit();
    this.getRfpDetails();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable) {
        this.isEditorDisabled = false;
        this.RFPForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.RFPForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  rfpdata: any;
  getRfpDetails() {
    const sub = this.api
      .getAPI(
        `/make1/nominations/?proposal_step=${this.id}&proposal_step__proposal=${this.proposalId}`
      )
      .subscribe((res: any) => {
        this.rfpdata = res;
        this.uploadedUrl = res.document || null;
        this.RFPForm.patchValue({
          comment: this.rfpdata?.justification,
        });
      });
    this.subscriptions.add(sub);
  }

  onUpload(event: any): void {
    const file = event.files?.[0];
    this.uploadedFileName = file.name;
    this.file = file;
  }

  onSubmit(): void {
    // if (this.commentForm.valid) {
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    if (this.file) {
      formData.append('document', this.file);
    }

    if (this.rfpdata) {
      const sub = this.api
        .putAPI(`/make1/nominations/${this.rfpdata.id}/`, formData)
        .subscribe((res: any) => {
          this.getRfpDetails();
          this.uploadedUrl = null;
          this.uploadedFileName = '';
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'SSCT updated successfully',
          });
        });
      this.subscriptions.add(sub);
    }
  }

  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: 'Proposal Name', value: this.proposalName },
        { key: 'SSCT', value: this.RFPForm.get('comment')?.value },
      ],
    };
    this.generatePDFEmitter.emit(payload);
  }
  getFileName(url: string): string {
    const fileName = url.split('/').pop() || 'Unknown File';
    return fileName.length > 35 ? fileName.substring(0, 30) + '...' : fileName;
  }
  clearUpload(fileUpload: any) {
    this.uploadedFileName = null;
    // this.uploadedUrl = null;
    fileUpload.clear();
  }

  getSystem(event: { page: number; search?: string } = { page: 1 }) {
    const page = event.page || 1;
    const search = event.search?.trim();

    let url = `/make1/nominations/member/`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    const sub = this.api.getAPI(url).subscribe((res) => {
     this.system = res
     
      this.totalRecords = res.count || 0;
    });
    this.subscriptions.add(sub);
  }

  addSystem() {
    this.roleForm.reset();
    this.roleForm.enable();
    this.showDialog = true;
  }
  onSubmitadd() {
    if (this.roleForm.valid) {
      const selectedIds = this.roleForm.value.selectedOptions;
      let payload = {
        nominations_id: this.rfpdata.id,
        user_id: this.roleForm.get('user').value,
        unit: this.roleForm.get('directorate').value,
        contact_details: this.roleForm.get('contact').value,
        role: this.roleForm.get('roleName').value,
      };
      const sub = this.api
        .postAPI('/make1/nominations/member/', payload)
        .subscribe((res: any) => {
          if (res) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Member added successfully',
            });
            this.showDialog = false;
            this.roleForm.reset();
            this.getSystem();
          } else {
            this.messageService.add({
              severity: 'failed',
              summary: 'failed',
              detail: res.name,
            });
          }
        });
      this.subscriptions.add(sub);
    }
  }
  viewMode = false;
  viewSystem(rowData: any) {
    this.viewMode = true;
    if (rowData && rowData.id) {
      this.isUpdatedialog = true;
      this.selectedsystem = rowData;
      this.roleForm.patchValue({
      user: rowData.user.id,
      directorate: rowData.unit,
      roleName: rowData.role,
      contact:rowData.contact_details
    });
      this.roleForm.disable();
    }
  }

  updateSystem(equipment: any): void {
    this.viewMode = false;
    this.roleForm.enable();
    this.isUpdatedialog = true;
    this.selectedsystem = equipment;
    this.roleForm.patchValue({
      user: equipment.user.id,
      directorate: equipment.unit,
      roleName: equipment.role,
      contact:equipment.contact_details
    });
  }

  onSubmitEq() {
    let sectionId = this.selectedsystem.id;
    const selectedIds = this.roleForm.value.selectedOptions;
    let payload = {
      nominations_id: this.rfpdata.id,
      user_id: this.roleForm.get('user').value,
      unit: this.roleForm.get('directorate').value,
      contact_details: this.roleForm.get('contact').value,
      role: this.roleForm.get('roleName').value,
    };
    const sub = this.api
      .putAPI(`/make1/nominations/member/${sectionId}/`, payload)
      .subscribe((res: any) => {
        if (res) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Member updated successfully',
          });
          this.isUpdatedialog = false;
          this.roleForm.reset();
          this.getSystem();
        } else {
          this.messageService.add({
            severity: 'failed',
            summary: 'Failed',
            detail: res.detail,
          });
        }
      });
    this.subscriptions.add(sub);
    this.isUpdatedialog = false;
  }

  showDeletePopup(equipment: any) {
    this.showDeleteDialog = true;
    this.selectedsystem = equipment;
  }
  deleteSystem() {
    let sectionId = this.selectedsystem.id;
    const sub = this.api
      .deleteAPI(`/make1/nominations/member/${sectionId}/`)
      .subscribe({
        next: (res: any) => {
          this.showDeleteDialog = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Incubator Deleted Successfully',
          });
          this.getSystem();
        },
        error: (err) => {
          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error',
          //   detail: 'Failed to delete the proposal. Please try again.',
          // });
        },
      });
    this.subscriptions.add(sub);
  }
  getUserList() {
    const sub = this.api.getAPI('/account/users/').subscribe((res: any) => {
      this.userList = res.data;
      this.userListCopy = [...this.userList]
    });
    this.subscriptions.add(sub);
  }
  getUnit() {
    const sub = this.api.getAPI('/master/units/').subscribe((res: any) => {
      this.unitList = res.data;
    });
    this.subscriptions.add(sub);
  }
    onUnitChange(event: any) {
    let unit_id = event.value
    this.userList = this.userListCopy.filter(user => user.unit?.id == unit_id);
  }
}
